<template>
<div class="MStepFour">
    <div v-if="resultData.reportstatus === 1" class="result_div success_div">
        <img class="inset_img" :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
        <p>您的股权激励报告已生成，<br/>点击下方按钮进行查看。</p>
        <span>此结果根据您填入的数据计算得出，<br/>人工智能生成结果仅供参考。</span>
        <div class="btn_div" @click="lookReport">查看报告</div>
    </div>
    <div v-else class="result_div error_div">
        <img class="qr_img" v-lazy="qrImgUrl" alt="">
        <p>很抱歉报告生成失败<br/>扫码添加微信客服获取报告</p>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
// import {Toast} from 'vant'
export default {
    name: 'MStepFour',
    data() {
        return {
            qrImgUrl: 'http://img.capwhale.com/gj_dyh.jpg', // 二维码图片
            resultData: {
                fullurl: '',
                orderno: '',
                reportstatus: 1
            }
        }
    },
    mounted() {},
    methods: {
        // 查看报告
        lookReport() {
            this.$router.push({name: 'MLookReport', query: {'orderno': this.resultData.orderno}})
        },
        // 获取股权激励结果数据
        getResultData(val) {
            // console.log('股权激励结果：', val)
            this.resultData = val
        },
        // 下载报告
        downloadPdf(url) {
            this.showPop = false
            window.open(url)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepFour {
    .result_div {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: calc(100vh - 3.7rem);
        .inset_img {
            width: 3.5rem;
            height: 2.3rem;
            margin-top: 0.8rem;
            margin-bottom: 0.4rem;
        }
        &>p {
            text-align: center;
            color: #333;
            line-height: 0.42rem;
            font-size: 0.28rem;
        }
        &>span {
            text-align: center;
            margin-top: 0.32rem;
            color: #999;
            line-height: 0.36rem;
            font-size: 0.22rem;
            padding: 0 0.24rem;
        }
        .btn_div {
            margin-top: 0.8rem;
            background-color: #409EFF;
            color: #fff;
            line-height: 0.8rem;
            text-align: center;
            width: 6.22rem;
            font-size: 0.32rem;
            border-radius: 0.4rem;
        }
    }
    .error_div {
        .qr_img {
            width: 2.1rem;
            height: 2.1rem;
            margin-top: 0.8rem;
            margin-bottom: 0.5rem;
        }
    }
    .from_warp {
        background-color: #fff;
        padding: 0.32rem;
        padding-top: 0.02rem;
        .btn_box {
            font-size: 0.32rem;
            width: 100vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: #409EFF;
            color: #FFF;
        }
    }
}
</style>